import { FIELD_VALUE_TYPE, GENERATOR_INPUT_TYPE, SEARCH_FIELD_TYPE } from '../constants'

export const getInputTypeByValueType = (
  valueType: FIELD_VALUE_TYPE | null,
  fieldType?: SEARCH_FIELD_TYPE
): GENERATOR_INPUT_TYPE => {
  switch (valueType) {
    case FIELD_VALUE_TYPE.DATETIME:
      if (fieldType === SEARCH_FIELD_TYPE.RANGE_OF_VALUES) {
        return GENERATOR_INPUT_TYPE.DATE_RANGE_PICKER
      }

      return GENERATOR_INPUT_TYPE.DATE_TIME_PICKER
    default:
      return GENERATOR_INPUT_TYPE.INPUT
  }
}
